import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";

export function NoPermissionCard() {
  const { t } = useTranslation("common");
  return (
    <div className="pt-4">
      <Card className="border-warning bg-warning/10">
        <CardHeader>
          <CardTitle className="text-warning flex items-center gap-2">
            <AlertTriangle /> {t("NoPermission")}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-warning">{t("NoPermissionForThisArea")}</p>
        </CardContent>
      </Card>
    </div>
  );
}
